export default {
  methods: {
    /**
    * @description 根据数组来确定单元格是否需要合并
    * @param val:String 需要合并的列name 如:'name' 'id'
    * @param rowIndex:Number 当前行的行数，由合并函数传入
    * @param colData:Object 当前列的数据，由合并函数传入
    * @return 返回值为一个数组表示该单元格是否需要合并; 说明: [0,0]表示改行被合并了 [n+,1]n为1时表示该单元格不动,n大于1时表示合并了N-1个单元格
    **/
    mergeAction (val, rowIndex, colData, rowMergeArry) {
      let _row = rowMergeArry[val].rowArr[rowIndex]
      let _col = _row > 0 ? 1 : 0
      return [_row, _col]
    },
    /**
    * @description 根据数组将指定对象转化为相应的数组
    * @param arr:Array[String] 必填 必须是字符串形式的数组
    * @param data:Array 必填 需要转化的对象
    *
    * @return 返回一个对象
    * 例：rowMerge(['name','value'], [{value:'1', name:'小明'}, {value:'2', name:'小明'}, {value:'3', name:'小明'}, {value:'1', name:'小明'}, {value:'1', name:'小明'}])
    * 返回值: {
    *          name:{
    *            rowArr: [5, 0, 0, 0, 0]
    *            rowMergeNum: 0,
    *          },
    *          value: {
    *            rowArr: [1, 1, 1, 2, 0],
    *            rowMergeNum: 3
    *          }
    *        }
    */
    rowMergeHandle (arr, data) {
      if (!Array.isArray(arr) && !arr.length) return false
      if (!Array.isArray(data) && !data.length) return false
      let needMerge = {}
      arr.forEach(i => {
        needMerge[i] = {
          rowArr: [],
          rowMergeNum: 0
        }
        data.forEach((item, index) => {
          if (index === 0) {
            needMerge[i].rowArr.push(1)
            needMerge[i].rowMergeNum = 0
          } else {
            if (item[i] === data[index - 1][i]) {
              needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1
              needMerge[i].rowArr.push(0)
            } else {
              needMerge[i].rowArr.push(1)
              needMerge[i].rowMergeNum = index
            }
          }
        })
      })
      return needMerge
    }
  }
}
